import React, { useContext } from "react";

import { ContextoListaApartamentos } from "../../../ApartamentList/contextoImoveis";

import { Container, Title, List, ListItem } from "./styles";

const ComoFunciona = () => {
  const { tema } = useContext(ContextoListaApartamentos);

  return (
    <Container>
      <Title tema={tema}>Como funciona a renegociação de parcelas?</Title>
      <List>
        <ListItem tema={tema}>
          <p>
            Consulte sua dívida e entenda o valor em aberto que precisará ser
            negociado;
          </p>
        </ListItem>
        <ListItem tema={tema}>
          <p>
            Simule e negocie do seu jeito, monte sua proposta ou aproveite
            nossas ofertas pré-aprovadas;
          </p>
        </ListItem>
        <ListItem tema={tema}>
          <p>
            Escolha a melhor opção de pagamento, à vista ou pagamento parcelado;
          </p>
        </ListItem>
        <ListItem tema={tema}>
          <p>
            Faça o pagamento da entrada e comece a organizar suas finanças! Tudo
            fácil e online.
          </p>
        </ListItem>
      </List>
    </Container>
  );
};

export default ComoFunciona;
